// Multilingual questions for Myth vs Fact Game
export const mythVsFactQuestions = {
  en: [
    // MYTH QUESTIONS (20 total)
    {
      id: 1,
      question: "All breast lumps are cancerous?",
      answer: false,
      type: "myth",
      explanation: "80-90% of breast lumps are benign (non-cancerous). However, every lump needs proper doctor evaluation for accurate diagnosis.",
      category: "Symptoms"
    },
    {
      id: 2,
      question: "Breast cancer only affects older women?",
      answer: false,
      type: "myth",
      explanation: "About 50% of breast cancer cases are diagnosed before age 50. Young women are also at risk and should be aware of symptoms.",
      category: "Age & Risk"
    },
    {
      id: 3,
      question: "Having family history means I'll definitely get cancer?",
      answer: false,
      type: "myth",
      explanation: "85-90% of breast cancer cases have NO family history. Most cases are sporadic, not hereditary.",
      category: "Genetics"
    },
    {
      id: 4,
      question: "Breast pain means cancer?",
      answer: false,
      type: "myth",
      explanation: "Breast pain is RARELY a sign of cancer. It's usually hormonal or cyclical and related to menstrual cycles.",
      category: "Symptoms"
    },
    {
      id: 5,
      question: "No lump means no cancer?",
      answer: false,
      type: "myth",
      explanation: "Early cancers often show as skin changes, nipple inversion, or dimpling FIRST, before any lump can be felt.",
      category: "Symptoms"
    },
    {
      id: 6,
      question: "Biopsy spreads cancer throughout the body?",
      answer: false,
      type: "myth",
      explanation: "Biopsy is completely SAFE and doesn't spread cancer. Delaying proper diagnosis is actually dangerous.",
      category: "Treatment"
    },
    {
      id: 7,
      question: "Mammograms cause cancer due to radiation?",
      answer: false,
      type: "myth",
      explanation: "Mammogram radiation dose is only 0.4mSv (equivalent to 7 weeks of background radiation). They are life-saving screening tools.",
      category: "Screening"
    },
    {
      id: 8,
      question: "Men don't get breast cancer?",
      answer: false,
      type: "myth",
      explanation: "About 1% of breast cancer cases occur in men. They have the same symptoms and need the same awareness as women.",
      category: "Gender"
    },
    {
      id: 9,
      question: "Breast cancer is a death sentence?",
      answer: false,
      type: "myth",
      explanation: "90% survival rate when caught early. Stage 1 breast cancer has a 99% survival rate. Early detection saves lives!",
      category: "Treatment"
    },
    {
      id: 10,
      question: "Wearing tight bras causes breast cancer?",
      answer: false,
      type: "myth",
      explanation: "There is no scientific evidence linking bra type or tightness to breast cancer risk. This is a persistent myth.",
      category: "Lifestyle"
    },
    {
      id: 11,
      question: "Self-examination replaces mammogram screening?",
      answer: false,
      type: "myth",
      explanation: "Self-exam finds only 70% of cancers and misses deep cancers. BOTH self-exam AND mammogram screening are needed together.",
      category: "Screening"
    },
    {
      id: 12,
      question: "Breastfeeding prevents cancer completely?",
      answer: false,
      type: "myth",
      explanation: "Breastfeeding reduces risk by only 4-5%, it doesn't eliminate cancer risk. Regular screening is still essential.",
      category: "Prevention"
    },
    {
      id: 13,
      question: "Antiperspirants cause breast cancer?",
      answer: false,
      type: "myth",
      explanation: "No scientific evidence supports this claim. Aluminum absorption through skin is minimal and not linked to cancer.",
      category: "Lifestyle"
    },
    {
      id: 14,
      question: "Sugar directly feeds cancer growth?",
      answer: false,
      type: "myth",
      explanation: "All cells use sugar for energy. Dietary sugar doesn't directly CAUSE cancer, though healthy diet is always recommended.",
      category: "Lifestyle"
    },
    {
      id: 15,
      question: "Abortion or contraception causes breast cancer?",
      answer: false,
      type: "myth",
      explanation: "No causal link has been scientifically proven. Real risk factors are primarily hormonal, genetic, and lifestyle-related.",
      category: "Lifestyle"
    },
    {
      id: 16,
      question: "Dense breasts mean high cancer risk?",
      answer: false,
      type: "myth",
      explanation: "Dense breasts make cancer detection harder on mammograms, but don't necessarily mean higher cancer risk.",
      category: "Screening"
    },
    {
      id: 17,
      question: "5 years cancer-free means completely cured?",
      answer: false,
      type: "myth",
      explanation: "20% of recurrences happen after 5 years. Lifetime monitoring and follow-up care are still needed.",
      category: "Treatment"
    },
    {
      id: 18,
      question: "Radiation therapy is too dangerous to use?",
      answer: false,
      type: "myth",
      explanation: "Targeted radiation therapy saves lives and is precisely controlled. Side effects are manageable and temporary.",
      category: "Treatment"
    },
    {
      id: 19,
      question: "Breast removal is the only treatment option?",
      answer: false,
      type: "myth",
      explanation: "80% of early-stage cancers can be treated with breast conservation surgery. Complete removal isn't always necessary.",
      category: "Treatment"
    },
    {
      id: 20,
      question: "Stress directly causes breast cancer?",
      answer: false,
      type: "myth",
      explanation: "Stress can weaken immunity but is not a direct cause of cancer. Managing stress is good for overall health.",
      category: "Lifestyle"
    },
    
    // FACT QUESTIONS (10 total)
    {
      id: 21,
      question: "Stage 1 breast cancer has 99% 5-year survival rate?",
      answer: true,
      type: "fact",
      explanation: "When breast cancer is found at Stage 1 (localized, <2cm, no lymph nodes), modern treatment cures 99% of women. Regular self-exam + mammogram makes early detection possible.",
      category: "Treatment"
    },
    {
      id: 22,
      question: "Self-exam finds 70% of breast lumps before doctor visits?",
      answer: true,
      type: "fact",
      explanation: "70% of breast lumps are discovered by women themselves during monthly self-exams. Do it Day 7-10 of your cycle when breasts are least tender. Upper outer quadrant focus!",
      category: "Prevention"
    },
    {
      id: 23,
      question: "50% breast cancer cases diagnosed before age 50?",
      answer: true,
      type: "fact",
      explanation: "In India, 50% of breast cancer occurs in women under 50 - much younger than global average. Family history, early periods, late pregnancy increase young women's risk.",
      category: "Age & Risk"
    },
    {
      id: 24,
      question: "85-90% breast cancers have NO family history?",
      answer: true,
      type: "fact",
      explanation: "Only 10-15% cases are hereditary. 85-90% women with breast cancer had no family history. Age, hormones, lifestyle affect everyone regardless of genetics.",
      category: "Genetics"
    },
    {
      id: 25,
      question: "Mammogram + ultrasound detects 95% early cancers?",
      answer: true,
      type: "fact",
      explanation: "Young Indian women often have dense breasts where mammogram alone misses 20-30% cancers. Ultrasound + mammogram together = 95% detection rate for early stage.",
      category: "Screening"
    },
    {
      id: 26,
      question: "Breastfeeding reduces risk by 4% per year breastfed?",
      answer: true,
      type: "fact",
      explanation: "Each year of breastfeeding lowers lifetime breast cancer risk by 4.3%. Total 12+ months breastfeeding = significant protection. Natural prevention!",
      category: "Prevention"
    },
    {
      id: 27,
      question: "1 new breast cancer diagnosis every 4 minutes in India?",
      answer: true,
      type: "fact",
      explanation: "India sees 200,000+ new cases yearly = 1 woman diagnosed every 4 minutes. 70% late stage detection. YOUR awareness can change this statistic.",
      category: "Statistics"
    },
    {
      id: 28,
      question: "50% breast cancers found in upper outer quadrant?",
      answer: true,
      type: "fact",
      explanation: "50% of all breast cancers develop in upper outer quadrant (towards armpit). Self-exam this area specially using circular motion with 3 fingers.",
      category: "Symptoms"
    },
    {
      id: 29,
      question: "90% overall survival with modern treatment?",
      answer: true,
      type: "fact",
      explanation: "90% of breast cancer patients survive 5+ years with current treatments. Early detection + targeted therapy = dramatic improvement over past decades.",
      category: "Treatment"
    },
    {
      id: 30,
      question: "Biopsy does NOT spread cancer?",
      answer: true,
      type: "fact",
      explanation: "Common myth delays diagnosis. Needle biopsy is safe, accurate, and essential. 80-90% 'suspicious lumps' prove benign. Don't delay - get it done!",
      category: "Treatment"
    }
  ],
  
  hi: [
    // मिथक प्रश्न (20 कुल)
    {
      id: 1,
      question: "सभी स्तन गांठें कैंसरयुक्त होती हैं?",
      answer: false,
      type: "myth",
      explanation: "80-90% स्तन गांठें सौम्य (गैर-कैंसरयुक्त) होती हैं। हालांकि, सटीक निदान के लिए हर गांठ का उचित डॉक्टर मूल्यांकन आवश्यक है।",
      category: "लक्षण"
    },
    {
      id: 2,
      question: "स्तन कैंसर केवल बड़ी उम्र की महिलाओं को प्रभावित करता है?",
      answer: false,
      type: "myth",
      explanation: "लगभग 50% स्तन कैंसर के मामले 50 वर्ष की आयु से पहले निदान किए जाते हैं। युवा महिलाएं भी जोखिम में हैं और उन्हें लक्षणों के बारे में जागरूक होना चाहिए।",
      category: "आयु और जोखिम"
    },
    {
      id: 3,
      question: "पारिवारिक इतिहास होने का मतलब है कि मुझे निश्चित रूप से कैंसर होगा?",
      answer: false,
      type: "myth",
      explanation: "85-90% स्तन कैंसर के मामलों में कोई पारिवारिक इतिहास नहीं होता। अधिकांश मामले छिटपुट होते हैं, वंशानुगत नहीं।",
      category: "आनुवंशिकी"
    },
    {
      id: 4,
      question: "स्तन दर्द का मतलब कैंसर है?",
      answer: false,
      type: "myth",
      explanation: "स्तन दर्द शायद ही कभी कैंसर का संकेत होता है। यह आमतौर पर हार्मोनल या चक्रीय होता है और मासिक धर्म चक्र से संबंधित होता है।",
      category: "लक्षण"
    },
    {
      id: 5,
      question: "कोई गांठ नहीं का मतलब कोई कैंसर नहीं?",
      answer: false,
      type: "myth",
      explanation: "प्रारंभिक कैंसर अक्सर त्वचा में परिवर्तन, निप्पल का अंदर की ओर मुड़ना, या गड्ढे के रूप में पहले दिखाई देते हैं, इससे पहले कि कोई गांठ महसूस की जा सके।",
      category: "लक्षण"
    },
    {
      id: 6,
      question: "बायोप्सी पूरे शरीर में कैंसर फैलाती है?",
      answer: false,
      type: "myth",
      explanation: "बायोप्सी पूरी तरह से सुरक्षित है और कैंसर नहीं फैलाती। उचित निदान में देरी करना वास्तव में खतरनाक है।",
      category: "उपचार"
    },
    {
      id: 7,
      question: "मैमोग्राम विकिरण के कारण कैंसर का कारण बनते हैं?",
      answer: false,
      type: "myth",
      explanation: "मैमोग्राम विकिरण खुराक केवल 0.4mSv है (पृष्ठभूमि विकिरण के 7 सप्ताह के बराबर)। वे जीवन बचाने वाले स्क्रीनिंग उपकरण हैं।",
      category: "जांच"
    },
    {
      id: 8,
      question: "पुरुषों को स्तन कैंसर नहीं होता?",
      answer: false,
      type: "myth",
      explanation: "लगभग 1% स्तन कैंसर के मामले पुरुषों में होते हैं। उनमें समान लक्षण होते हैं और महिलाओं की तरह ही जागरूकता की आवश्यकता होती है।",
      category: "लिंग"
    },
    {
      id: 9,
      question: "स्तन कैंसर मौत की सजा है?",
      answer: false,
      type: "myth",
      explanation: "जल्दी पकड़े जाने पर 90% जीवित रहने की दर। स्टेज 1 स्तन कैंसर में 99% जीवित रहने की दर है। शीघ्र पता लगाना जीवन बचाता है!",
      category: "उपचार"
    },
    {
      id: 10,
      question: "टाइट ब्रा पहनने से स्तन कैंसर होता है?",
      answer: false,
      type: "myth",
      explanation: "ब्रा के प्रकार या कसावट को स्तन कैंसर के जोखिम से जोड़ने वाला कोई वैज्ञानिक प्रमाण नहीं है। यह एक लगातार मिथक है।",
      category: "जीवनशैली"
    },
    {
      id: 11,
      question: "स्व-परीक्षण मैमोग्राम स्क्रीनिंग की जगह लेता है?",
      answer: false,
      type: "myth",
      explanation: "स्व-परीक्षा केवल 70% कैंसर पाती है और गहरे कैंसर को छोड़ देती है। स्व-परीक्षा और मैमोग्राम स्क्रीनिंग दोनों एक साथ आवश्यक हैं।",
      category: "जांच"
    },
    {
      id: 12,
      question: "स्तनपान पूरी तरह से कैंसर को रोकता है?",
      answer: false,
      type: "myth",
      explanation: "स्तनपान जोखिम को केवल 4-5% कम करता है, यह कैंसर के जोखिम को समाप्त नहीं करता। नियमित जांच अभी भी आवश्यक है।",
      category: "रोकथाम"
    },
    {
      id: 13,
      question: "एंटीपर्सपिरेंट स्तन कैंसर का कारण बनते हैं?",
      answer: false,
      type: "myth",
      explanation: "कोई वैज्ञानिक प्रमाण इस दावे का समर्थन नहीं करता। त्वचा के माध्यम से एल्यूमीनियम अवशोषण न्यूनतम है और कैंसर से जुड़ा नहीं है।",
      category: "जीवनशैली"
    },
    {
      id: 14,
      question: "चीनी सीधे कैंसर की वृद्धि को बढ़ाती है?",
      answer: false,
      type: "myth",
      explanation: "सभी कोशिकाएं ऊर्जा के लिए चीनी का उपयोग करती हैं। आहार चीनी सीधे कैंसर का कारण नहीं बनती, हालांकि स्वस्थ आहार हमेशा अनुशंसित है।",
      category: "जीवनशैली"
    },
    {
      id: 15,
      question: "गर्भपात या गर्भनिरोधक स्तन कैंसर का कारण बनता है?",
      answer: false,
      type: "myth",
      explanation: "कोई कारण संबंध वैज्ञानिक रूप से सिद्ध नहीं हुआ है। वास्तविक जोखिम कारक मुख्य रूप से हार्मोनल, आनुवंशिक और जीवनशैली से संबंधित हैं।",
      category: "जीवनशैली"
    },
    {
      id: 16,
      question: "घने स्तनों का मतलब उच्च कैंसर जोखिम है?",
      answer: false,
      type: "myth",
      explanation: "घने स्तन मैमोग्राम पर कैंसर का पता लगाना कठिन बनाते हैं, लेकिन जरूरी नहीं कि उच्च कैंसर जोखिम का मतलब हो।",
      category: "जांच"
    },
    {
      id: 17,
      question: "5 साल कैंसर मुक्त का मतलब पूरी तरह से ठीक हो गया?",
      answer: false,
      type: "myth",
      explanation: "20% पुनरावृत्ति 5 साल के बाद होती है। जीवन भर निगरानी और अनुवर्ती देखभाल अभी भी आवश्यक है।",
      category: "उपचार"
    },
    {
      id: 18,
      question: "विकिरण चिकित्सा उपयोग करने के लिए बहुत खतरनाक है?",
      answer: false,
      type: "myth",
      explanation: "लक्षित विकिरण चिकित्सा जीवन बचाती है और सटीक रूप से नियंत्रित होती है। दुष्प्रभाव प्रबंधनीय और अस्थायी हैं।",
      category: "उपचार"
    },
    {
      id: 19,
      question: "स्तन हटाना एकमात्र उपचार विकल्प है?",
      answer: false,
      type: "myth",
      explanation: "80% प्रारंभिक चरण के कैंसर का इलाज स्तन संरक्षण सर्जरी से किया जा सकता है। पूर्ण हटाना हमेशा आवश्यक नहीं है।",
      category: "उपचार"
    },
    {
      id: 20,
      question: "तनाव सीधे स्तन कैंसर का कारण बनता है?",
      answer: false,
      type: "myth",
      explanation: "तनाव प्रतिरक्षा को कमजोर कर सकता है लेकिन कैंसर का प्रत्यक्ष कारण नहीं है। तनाव का प्रबंधन समग्र स्वास्थ्य के लिए अच्छा है।",
      category: "जीवनशैली"
    },
    
    // तथ्य प्रश्न (10 कुल)
    {
      id: 21,
      question: "स्टेज 1 स्तन कैंसर में 99% 5-वर्षीय जीवित रहने की दर है?",
      answer: true,
      type: "fact",
      explanation: "जब स्तन कैंसर स्टेज 1 (स्थानीयकृत, <2cm, कोई लिम्फ नोड्स नहीं) पर पाया जाता है, तो आधुनिक उपचार 99% महिलाओं को ठीक करता है। नियमित स्व-परीक्षा + मैमोग्राम शीघ्र पता लगाना संभव बनाता है।",
      category: "उपचार"
    },
    {
      id: 22,
      question: "स्व-परीक्षा डॉक्टर की यात्रा से पहले 70% स्तन गांठों को पाती है?",
      answer: true,
      type: "fact",
      explanation: "70% स्तन गांठें महिलाओं द्वारा मासिक स्व-परीक्षा के दौरान खुद खोजी जाती हैं। इसे अपने चक्र के दिन 7-10 पर करें जब स्तन कम कोमल हों। ऊपरी बाहरी चतुर्थांश पर ध्यान दें!",
      category: "रोकथाम"
    },
    {
      id: 23,
      question: "50% स्तन कैंसर के मामले 50 वर्ष की आयु से पहले निदान किए जाते हैं?",
      answer: true,
      type: "fact",
      explanation: "भारत में, 50% स्तन कैंसर 50 वर्ष से कम उम्र की महिलाओं में होता है - वैश्विक औसत से बहुत कम उम्र में। पारिवारिक इतिहास, जल्दी मासिक धर्म, देर से गर्भावस्था युवा महिलाओं के जोखिम को बढ़ाती है।",
      category: "आयु और जोखिम"
    },
    {
      id: 24,
      question: "85-90% स्तन कैंसर में कोई पारिवारिक इतिहास नहीं होता?",
      answer: true,
      type: "fact",
      explanation: "केवल 10-15% मामले वंशानुगत होते हैं। 85-90% स्तन कैंसर वाली महिलाओं का कोई पारिवारिक इतिहास नहीं था। आयु, हार्मोन, जीवनशैली आनुवंशिकी की परवाह किए बिना सभी को प्रभावित करती है।",
      category: "आनुवंशिकी"
    },
    {
      id: 25,
      question: "मैमोग्राम + अल्ट्रासाउंड 95% प्रारंभिक कैंसर का पता लगाता है?",
      answer: true,
      type: "fact",
      explanation: "युवा भारतीय महिलाओं में अक्सर घने स्तन होते हैं जहां अकेले मैमोग्राम 20-30% कैंसर को छोड़ देता है। अल्ट्रासाउंड + मैमोग्राम एक साथ = प्रारंभिक चरण के लिए 95% पता लगाने की दर।",
      category: "जांच"
    },
    {
      id: 26,
      question: "स्तनपान प्रति वर्ष स्तनपान से 4% जोखिम कम करता है?",
      answer: true,
      type: "fact",
      explanation: "स्तनपान का प्रत्येक वर्ष जीवन भर स्तन कैंसर के जोखिम को 4.3% कम करता है। कुल 12+ महीने स्तनपान = महत्वपूर्ण सुरक्षा। प्राकृतिक रोकथाम!",
      category: "रोकथाम"
    },
    {
      id: 27,
      question: "भारत में हर 4 मिनट में 1 नया स्तन कैंसर निदान?",
      answer: true,
      type: "fact",
      explanation: "भारत में सालाना 200,000+ नए मामले देखे जाते हैं = हर 4 मिनट में 1 महिला का निदान। 70% देर से चरण का पता लगाना। आपकी जागरूकता इस आंकड़े को बदल सकती है।",
      category: "आंकड़े"
    },
    {
      id: 28,
      question: "50% स्तन कैंसर ऊपरी बाहरी चतुर्थांश में पाए जाते हैं?",
      answer: true,
      type: "fact",
      explanation: "सभी स्तन कैंसर का 50% ऊपरी बाहरी चतुर्थांश (बगल की ओर) में विकसित होता है। 3 उंगलियों के साथ गोलाकार गति का उपयोग करके इस क्षेत्र की विशेष रूप से स्व-परीक्षा करें।",
      category: "लक्षण"
    },
    {
      id: 29,
      question: "आधुनिक उपचार के साथ 90% समग्र जीवित रहना?",
      answer: true,
      type: "fact",
      explanation: "90% स्तन कैंसर रोगी वर्तमान उपचारों के साथ 5+ वर्ष जीवित रहते हैं। शीघ्र पता लगाना + लक्षित चिकित्सा = पिछले दशकों में नाटकीय सुधार।",
      category: "उपचार"
    },
    {
      id: 30,
      question: "बायोप्सी कैंसर नहीं फैलाती?",
      answer: true,
      type: "fact",
      explanation: "आम मिथक निदान में देरी करता है। सुई बायोप्सी सुरक्षित, सटीक और आवश्यक है। 80-90% 'संदिग्ध गांठें' सौम्य साबित होती हैं। देरी न करें - इसे करवाएं!",
      category: "उपचार"
    }
  ]
};
